import { render, staticRenderFns } from "./UpsertPromotion.vue?vue&type=template&id=d7c4b468&scoped=true"
import script from "./UpsertPromotion.vue?vue&type=script&lang=js"
export * from "./UpsertPromotion.vue?vue&type=script&lang=js"
import style0 from "./UpsertPromotion.vue?vue&type=style&index=0&id=d7c4b468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c4b468",
  null
  
)

export default component.exports